<template>
    <div class="mp_list">
        <div class="mp_total_koin">
            총 보유코인 : {{ returnKoinCnt() }}
            <el-button class="mp_el_bnt" type="koin" @click="openModal('koin-create-modal')"> 코인지급</el-button>
        </div>
        <div class="koin_wrap" v-for="koin in paymentData" :key="`koin_id${koin.tbm_idx}`">
            {{ returnDateUnix(koin.created_at, 'YYYY.MM.DD HH:mm') }} {{returnOrderNum(koin)}}
            <br>
            <div class="koin_content_wrap">
                <div>{{ koin.tbm_title }}</div>
                <div class="koin_cnt"><span>{{ returnRemainCnt(koin) }}</span> / {{ returnItemCnt(koin)  }}</div>
                <div class="koin_date">{{ returnDateUnix(koin.created_at, 'YYYY.MM.DD') }} ~
                    {{ returnDateUnix(koin.tbm_expire_date, 'YYYY.MM.DD') }}
                </div>
            </div>
            <div style="display: inline-block">
                <el-button class="mp_el_bnt" type="delete" @click="openModal('koin-delete-modal',koin.tbm_idx)">삭제</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import dateMixins from "@/mixins/dateMixins";

export default {
    name: "PaymentListKoinLayout",
    mixins: [dateMixins],
    inject: ['paymentListSetData'],
    components: {},
    provide() {
        return {}
    },
    props: {
        paymentData: {default: () => []},
        memberData: {
            default: () => {
            }
        },
    },
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        openModal(name,idx) {
            this.$modal.show(name , {memberKey:this.memberData.mb_no,koinKey :idx })
        },
        returnKoinCnt() {
            if (!util.isEmpty(this.memberData) && !util.isEmpty(this.memberData.Koin)) {
                return this.memberData.Koin[0].koin
            } else return 0
        },
        returnRemainCnt(koin){
            return Number(koin.remain_cnt) + Number(koin.remain_extra)
        },
        returnItemCnt(koin){
            return Number(koin.tbm_cnt) + Number(koin.tbm_extra)

        },
        returnOrderNum(koin){
            !util.isEmpty(koin.o_id) ? `/ ${koin.o_id}` : ''
        }

    },
    watch: {},
}
</script>

<style scoped>

</style>